import React from 'react';
import './Navbar.css';

function Navbar() {
  return (
    <nav className="Navbar">
      <ul>
        <li><a href="#home"><i className="fas fa-home"></i><span className="nav-text">Home</span></a></li>
        <li><a href="#about"><i className="fas fa-user"></i><span className="nav-text">About</span></a></li>
        <li><a href="#education"><i className="fas fa-graduation-cap"></i><span className="nav-text">Education</span></a></li>
        <li><a href="#projects"><i className="fas fa-folder-open"></i><span className="nav-text">Projects</span></a></li>
        <li><a href="#contact"><i className="fas fa-envelope"></i><span className="nav-text">Contact</span></a></li>
      </ul>
    </nav>
  );
}

export default Navbar;